<div class="container py-0 pt-5">
  <div class="row border rounded-4 p-0 shadow-sm align-items-center">
    <!-- Image -->
    <div class="col-12 col-md-4 p-0">
      <div class="ratio ratio-1x1 max-h-200">
        <img [src]="listing?.imageUrl" alt="Listing Image"
          class="img-fluid rounded-4 shadow-sm object-fit-cover w-100 mx-auto d-block" />
      </div>
    </div>

    <div class="col-12 col-md-8 mb-sm-2">
      <p class="small text-muted mb-2">
        <strong class="text-dark">{{ listing?.createdBy || "Admin" }}</strong>
        | {{ listing?.timestampedAt | date : "mediumDate" }}
      </p>
      <h3 class="fw-bold lh-sm display-6 m-0">
        {{ listing?.title }}
      </h3>
    </div>
  </div>
</div>

<!-- Full Page Section -->
@if (listing) {
  <div class="bg-light py-5">
    <div class="container">
      <div class="row">
        <!-- Left Content -->
        <div class="col-12 col-lg-9">
          <div class="bg-white rounded-4 shadow-sm p-4">
            <p class="text-secondary mb-4">
              Don't miss out on $5 kids' and toddler pajamas at Walmart. Some of
              the themes and sizes are already selling out. I'm seeing several
              characters and movies still available, including Frozen, Stitch,
              Cars, Spider-Man, and more.
            </p>
            <!-- Product Box -->
            <div class="border rounded-4 p-4 mb-4">
              <div class="row g-3 align-items-start">
                <!-- Product Image -->
                <div class="col-md-3 text-start">
                  <!-- FULL WIDTH IMAGE -->
                  <img [src]="listing?.imageUrl" class="rounded-4 shadow-sm img-fluid w-100 object-fit-cover mb-3"
                    style="height: 320px" />
                </div>
                <!-- Right Details -->
                <div class="col-md-9">
                  <small class="fw-semibold text-muted">
                    {{ listing?.category }}
                  </small>
                  <h5 class="mt-1 fw-bold mb-1">
                    {{ listing?.name }}
                  </h5>
                  @if (isDiscounted()) {
                    <span class="fw-semibold text-danger fs-5 me-1">
                      ₹ {{ listing?.listingPrice }}
                    </span>
                    <span class="text-muted text-decoration-line-through fs-6 me-1">
                      ₹ {{ listing?.price }}
                    </span>
                    @if (showDiscountBadge()) {
                      <span class="badge rounded-pill text-dark" style="background-color: #f2c600"
                        >
                        {{ listing?.discount }}% off
                      </span>
                    }
                  } @else {
                    <span class="fw-semibold text-danger fs-5">
                      ₹ {{ listing?.price }}
                    </span>
                  }
                  <div class="d-flex align-items-center gap-2 mb-2">
                    <i class="fa-solid fa-cart-shopping text-warning"></i>
                    <span class="fw-semibold">SKU: {{ listing?.sku }}</span>
                  </div>
                  <div class="d-flex flex-column gap-2">
                    <a class="fw-semibold text-decoration-none text-dark small">
                      {{ listing?.name }}, ₹ {{ listing?.listingPrice ? listing?.listingPrice : listing?.price }} →
                    </a>
                    <a [href]="listing?.externalProductLink" target="_blank" rel="noopener noreferrer" role="button"
                      class="btn btn-warning fw-bold rounded-pill px-4 py-2">
                      Get Deal →
                      <span class="text-dark small">
                        {{ getSiteName(listing?.externalProductLink) }}
                      </span>
                    </a>
                  </div>
                  <div class="mt-2 d-flex align-items-center justify-content-between">
                    <p class="text-muted small mt-3">
                      Exp:{{ listing?.expiresAt }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Right Empty Space -->
        <div class="col-12 col-lg-4"></div>
      </div>
    </div>
  </div>
}

<!-- Loader -->
@if (loading) {
  <div class="text-center py-5">
    <div class="spinner-border"></div>
  </div>
}